import React, { useState } from 'react';
import { Grid, TextField, Button, IconButton, Typography, Box, Card, CircularProgress } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import toast from 'react-hot-toast';
import axios from './../../../axios/api';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const FormNotifications = () => {
    const [Title, setTitle] = useState('');
    const [Descriptions, setDescriptions] = useState('');
    const [LoadingButton, setLoadingButton] = useState(false);
    const [LinkAdv, setLinkAdv] = useState('');

    const [errors, setErrors] = useState({ title: '', message: '', link: '' });

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
        if (errors.title) {
            setErrors((prevErrors) => ({ ...prevErrors, title: '' }));
        }
    };

    const handleDescChange = (event) => {
        setDescriptions(event.target.value);
        if (errors.message) {
            setErrors((prevErrors) => ({ ...prevErrors, message: '' }));
        }
    };

    const handleLinkAdvChange = (event) => {
        setLinkAdv(event.target.value);
        if (errors.link) {
            setErrors((prevErrors) => ({ ...prevErrors, link: '' }));
        }
    };

    const reseteState = () => {
        setTitle('');
        setDescriptions('');
        setLinkAdv('');
    }

    const sendNotification = async () => {
        try {
            setLoadingButton(true);

            // Send the base64 string using axios
            const res = await axios.post('/admin/notification/send-notification', {
                title: Title,
                message: Descriptions,
                link: LinkAdv
            });

            toast.success(res.data?.message);
            reseteState();

        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred');
            if (error.response?.status === 422) {
                setErrors({
                    title: error.response.data.data.title ? error.response.data.data.title[0] : '',
                    message: error.response.data.data.message ? error.response.data.data.message[0] : '',
                    link: error.response.data.data.link ? error.response.data.data.link[0] : '',

                });

            }
        } finally {
            setLoadingButton(false);
        }
    };

    return (
        <div dir="rtl">
            <Card variant="outlined" sx={{ margin: 0, width: '100%' }}>
                <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12}>
                        <TextField
                            id="title"
                            label="عنوان اعلان"
                            type="text"
                            variant="outlined"
                            placeholder='عنوان اعلان را وارد کنید'
                            fullWidth
                            value={Title}
                            onChange={handleTitleChange}
                            error={Boolean(errors.title)}
                            helperText={errors.title}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12}>
                        <TextField
                            id="description"
                            label="توضیح اعلان"
                            type="text"
                            variant="outlined"
                            placeholder='توضیح اعلان را وارد کنید'
                            fullWidth
                            value={Descriptions}
                            onChange={handleDescChange}
                            error={Boolean(errors.message)}
                            helperText={errors.message}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12}>
                        <TextField
                            id="LinkAdv"
                            label="لینک تبلیغاتی"
                            type="text"
                            variant="outlined"
                            placeholder='... https://google.com/'
                            fullWidth
                            value={LinkAdv}
                            onChange={handleLinkAdvChange}
                            error={Boolean(errors.link)}
                            helperText={errors.link}
                        />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12}>

                        <Button color="secondary"


                            onClick={sendNotification}
                            disabled={LoadingButton}
                            fullWidth variant="contained" size="large">
                            {LoadingButton && <CircularProgress size={24} color="inherit" />}

                            <Typography color="white">ثبت اعلان جدید</Typography>
                        </Button>

                    </Grid>
                </Grid>
            </Card>

        </div>
    );
};

export default FormNotifications;
